export default __webpack_public_path__ + "static/media/ruby.67bc5fac.svg";